var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: _vm.dialogWidth },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "resizable-card",
          class: { "no-select": _vm.resizing },
          style: { height: _vm.dialogHeight + "px" },
        },
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [_vm._v("Artefact")]),
          ]),
          _c(
            "v-card-text",
            { staticClass: "resizable-card__body" },
            [
              _c("v-text-field", {
                attrs: { label: "Artefact", outlined: "" },
                model: {
                  value: _vm.model.artefact,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "artefact", $$v)
                  },
                  expression: "model.artefact",
                },
              }),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "X1", type: "number", outlined: "" },
                        model: {
                          value: _vm.model.rect[0][0],
                          callback: function ($$v) {
                            _vm.$set(_vm.model.rect[0], 0, _vm._n($$v))
                          },
                          expression: "model.rect[0][0]",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Y1", type: "number", outlined: "" },
                        model: {
                          value: _vm.model.rect[0][1],
                          callback: function ($$v) {
                            _vm.$set(_vm.model.rect[0], 1, _vm._n($$v))
                          },
                          expression: "model.rect[0][1]",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "X2", type: "number", outlined: "" },
                        model: {
                          value: _vm.model.rect[1][0],
                          callback: function ($$v) {
                            _vm.$set(_vm.model.rect[1], 0, _vm._n($$v))
                          },
                          expression: "model.rect[1][0]",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Y2", type: "number", outlined: "" },
                        model: {
                          value: _vm.model.rect[1][1],
                          callback: function ($$v) {
                            _vm.$set(_vm.model.rect[1], 1, _vm._n($$v))
                          },
                          expression: "model.rect[1][1]",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-select", {
                attrs: {
                  items: _vm.rotateOptions,
                  label: "Rotate",
                  outlined: "",
                },
                model: {
                  value: _vm.model.rotate,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "rotate", _vm._n($$v))
                  },
                  expression: "model.rotate",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "resizable-card__actions" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
          _c("div", {
            staticClass: "resize-handle",
            on: { mousedown: _vm.startResize },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }